// let loaderImage = require("../img/loading-spinner-arrow.gif");
// let loaderImage = require("../img/loading-spinner-blue.gif");
export const ADMIN_SIGNIN_FAIL = 'ADMINSIGNINFAIL';
export const ADD_USER = 'ADDUSER';
export const GET_USER_LIST = 'GETUSERLIST';
export const GET_USER_BY_ID = 'GETUSERBYID';
export const UPDATE_USER = 'UPDATEUSER';

export const BREAD_CRUMB_TITLE = 'BREADCRUMBTITLE';
export const SIGN_IN_USER = 'SIGNINUSER';
export const SIGN_UP_USER = 'SIGNUPUSER';
export const LOG_OUT = 'LOGOUT';
export const FORGOT_PASSWORD = 'FORGOTPASSWORD';
export const ACTIVATE_ACCOUNT = 'ACTIVATEACCOUNT';
export const RESET_PASSWORD = 'RESETPASSWORD';
export const GET_APPOINTMENT = 'GETAPPOINTMENT';    
export const GET_APPOINTMENT_DETAILS = 'GETAPPOINTMENTDETAILS';
export const CANCEL_APPOINTMENT = 'CANCELAPPOINTMENT';
export const CHANGE_EMAIL = 'CHANGEEMAIL';
export const UNLOCK_ACCOUNT = 'UNLOCKACCOUNT';
export const UNSUBSCRIBE_EMAILS = 'UNSUBSCRIBEEMAILS'
export const UNSUBSCRIBE_EMAILS_VIA_PROFILE = 'UNSUBSCRIBEEMAILSVIAPROFILE'
export const OTP_VERIFICATION = 'OTPVERIFICATION'
export const GET_SPECIALIST_FOR_IMAGES = 'GETSPECIALISTFORIMAGES';
export const GET_APPROVED_SPECIALIST_FOR_IMAGES ='GETAPPROVEDSPECIALISTFORIMAGES';
export const GET_APPROVED_BLOGS_FOR_IMAGES = 'GETAPPROVEDBLOGSFORIMAGES';
export const GET_BLOGS_FOR_IMAGES = 'GETBLOGSFORIMAGES'
export const UPDATE_PROFILE_IMAGE_VERIFIED = 'UPDATEPROFILEIMAGEVERIFIED';
export const UPDATE_BLOGS_IMAGE_VERIFIED = 'UPDATEBLOGSIMAGEVERIFIED'
//Users Constants
export const GET_USERS = 'GETUSERS';
export const GET_USER_DETAILS = 'GETUSERDETAILS';
export const GET_ROLES = 'GETROLES';
export const GET_PATIENT_IMAGE = 'GETPATIENTIMAGE';
export const GET_USER_DETAILS_ON_UPDATE = 'GETUSERDETAILSONUPDATE';


//Specialist Constants
export const GET_SPECIALISTS_LIST = 'GETSPECIALISTSLIST';
export const GET_CONVERTED_CURRENCY = 'GETCONVERTEDCURRENCY';

export const GET_SPECIALIST_DETAIL_CALENDAR = 'GETSPECIALISTDETAILCALENDAR';
export const GET_SPECIALIST_DETAIL = 'GETSPECIALISTDETAIL';
export const GET_EXPERIENCE_LIST = 'GETEXPERIENCELIST';
export const GET_SPECIALIST_PROFILE = 'GETSPECIALISTPROFILE';
export const SAVE_AVAILABILITY = 'SAVEAVAILABILITY';
export const CHECK_ZIPCODE = 'CHECKZIPCODE';
export const DELETE_AVAILABILITY = 'DELETEAVAILABILITY';
export const GET_AVAILABILITY = 'GETAVAILABILITY';
export const GET_OTHER_CONSULTATION_ADDRESS = 'GETOTHERCONSULTATIONADDRESS';
export const GET_MY_FEEDBACK = 'GETMYFEEDBACK';
export const GET_MY_FEEDBACK_DETAIL = 'GETMYFEEDBACKDETAIL';
export const VERIFY_SPECIALIST_STRIPE = 'VERIFYSPECIALISTSTRIPE';

export const SPECIALIST_PASSWORD_CHANGE_SUCCESS = 'SPECIALISTPASSWORDCHANGESUCCESS';
export const RESET_SPECIALIST_PASSWORD_CHANGE_SUCCESS = 'RESETSPECIALISTPASSWORDCHANGESUCCESS';

export const SPECIALIST_EMAIL_CHANGE_SUCCESS = 'SPECIALISTEMAILCHANGESUCCESS';
export const RESET_SPECIALIST_EMAIL_CHANGE_SUCCESS = 'RESETSPECIALISTEMAILCHANGESUCCESS';

export const CHANGE_SPECIALIST_PHONE_NO = "CHANGE_SPECIALIST_PHONE_NO";





export const GET_PRESCRIPTION_DATA = 'GETPRESCRIPTIONDATA';
export const GET_APPOINTMENTS_FOR_MONTH = 'GETAPPOINTMENTSFORMONTH';
export const GET_APPOINTMENTS_FOR_DAY = 'GETAPPOINTMENTSFORDAY';
export const GET_SPECIALIST_DETAIL_FOR_BLOCK = 'GETSPECIALISTDETAILFORBLOCK';
export const GET_SPECIALIST_BLOCKINGS = 'GETSPECIALISTBLOCKINGS';
export const GET_SPECIALIST_PATIENTS = 'GETSPECIALISTPATIENTS';
export const GET_SPECIALIST_STRIPE_DETAILS = 'GETSPECIALISTSTRIPEDETAILS';

//Specialization
export const GET_SPECIALIZATION_LIST = 'GETSPECIALIZATIONLIST';
export const GET_SPECIALISTS_ASSISTANT_LIST = 'GETSPECIALISTSASSISTANTLIST'
export const GET_SUBSPECIALIZATION_LIST = 'GETSUBSPECIALIZATIONLIST';
export const DASH_GET_SPECIALIZATION_LIST = 'DASHGETSPECIALIZATIONLIST';
export const GET_CONDITIONAL_PROCEDURE_MAPPING_LIST = 'GETCONDITIONALPROCEDUREMAPPINGLIST';


//Specialist Blog
export const ADD_SPECIALIST_BLOG = 'ADDSPECIALISTBLOG';
export const GET_SPECIALIST_BLOG_LIST = 'GETSPECIALISTBLOGLIST';
export const GET_SPECIALIST_BLOG_BY_ID = 'GETSPECIALISTBLOGBYID';
export const DELETE_SPECIALIST_BLOG = 'DELETESPECIALISTBLOG';
export const GET_ALL_BLOG_LIST = 'GETALLBLOGLIST';
export const LIKE_AND_UNLIKE_BLOG = 'LIKEANDUNLIKEBLOG';
export const FAVOUITE_AND_UNFAVOUITE_BLOG = 'FAVOUITEANDUNFAVOUITEBLOG';
export const GET_BLOG_DETAILS_BY_ID = 'GETBLOGDETAILSBYID';
export const GET_MARKETING_ALL_BLOG_LIST = 'GETMARKETINGALLBLOGLIST';
export const GET_MARKETING_BLOG_DETAILS_BY_ID = 'GETMARKETINGBLOGDETAILSBYID';

//Appointment
export const COMPANY_EXISTANCE = 'Company does not exist, please select company from list.';
export const GET_APPOINTMENTS = 'GETAPPOINTMENTS';
export const GET_SPECIALISTAVABILITY = 'GETSPECIALISTAVABILITY';
export const GET_SPECIALIST_BLOCK_DATES = 'GETSPECIALISTBLOCKDATES';
export const BOOK_APPOINTMENT = 'BOOKAPPOINTMENT';
export const ADD_APPOINTMENT_DETAILS = 'ADDAPPOINTMENTDETAILS';
export const GET_PATIENT_HISTORY = 'GETPATIENTHISTORY';
export const CREATE_SESSIONID_TOKEN = 'CREATESESSIONIDTOKEN';
export const DISCONNECT_SESSIONID_TOKEN = 'DISCONNECTSESSIONIDTOKEN';
export const GET_PATIENT_ALL_HISTORY = 'GETPATIENTALLHISTORY';
export const GET_RATING_QUESTIONS = 'GETRATINGQUESTIONS';
export const ADD_RATING = 'ADDRATING';
export const DONT_REMIND_FEEDBACK_AGAIN = 'DONTREMINDFEEDBACKAGAIN';
export const GET_REMINDER_FEEDBACK = 'GETREMINDERFEEDBACK';

export const GET_APPOINTMENT_DETAIL_RATE = 'GET_APPOINTMENT_DETAIL_RATE';


//upload document
export const UPLOAD_APPOINTMENT_DOCUMENT = 'UPLOADAPPOINTMENTDOCUMENT';
export const GET_DOCUMENT_TYPE = 'GETDOCUMENTTYPE';
export const GET_ALL_DOCUMENT_TYPES = 'GETALLDOCUMENTTYPES';
export const DELETE_DOCUMENT = 'DELETEDOCUMENT';
export const GET_APPOINTMENT_DOCUMENT = 'GETAPPOINTMENTDOCUMENT';
export const UPLOAD_SPECIALIST_DOCUMENT = 'UPLOADSPECIALISTDOCUMENT';
export const GET_SPECIALIST_DOCUMENT = 'GETSPECIALISTDOCUMENT';
export const GET_SPECIALIST_DOCUMENT_BY_ID = 'GETSPECIALISTDOCUMENTBYID'
export const GET_SPECIALIST_DOCUMENT_AND_STATUS = "GETSPECIALISTDOCUMENTANDSTATUS"



//Blood Group
export const GET_BLOOD_GROUP_LIST = 'GETBLOODGROUPLIST'

export const DELETE_APPOINTMENT = 'DELETEAPPOINTMENT';
export const GET_SPECIALISTS_ALL_AVAILABILITY = 'GETSPECIALISTSALLAVAILABILITY';

//Country
export const GET_COUNTRIES_LIST = 'GETCOUNTRIESLIST';
export const GET_STATES_LIST = 'GETSTATESLIST';
export const GET_USER_DETAILS_FOR_IMAGE = 'GETUSERDETAILSFORIMAGE'
export const GET_APPOINTMENTS_COUNT = 'GETAPPOINTMENTSCOUNT';
export const GET_QUESTION_RATING = 'GETQUESTIONRATING';
export const ADD_CURRENCY_FILTER = 'ADDCURRENCYFILTER'
export const LIST_CURRENCY_FILTER = 'LISTCURRENCYFILTER'

export const UPDATE_APPOINTMENT_SHOW = 'UPDATEAPPOINTMENTSHOW';
export const SAVE_CONSULTATION = 'SAVECONSULTATION';
export const GET_CONSULTATION_DETAIL = 'GETCONSULTATIONDETAIL';
export const GET_PATIENT_ALL_CONSULT_HISTORY = 'GETPATIENTALLCONSULTHISTORY';
export const NO_SHOW_APPOINTMENT = 'NOSHOWAPPOINTMENT';
export const VERIFY_PASSWORD = 'VERIFYPASSWORD';
export const GET_APPOINTMENTS_FOR_HEALTH_RECORD = 'GETAPPOINTMENTSFORHEALTHRECORD';
export const STRIPE_PAYMENT = 'STRIPEPAYMENT';
export const PATIENT_VS_APPOINTMENTS = 'PATIENTVSAPPOINTMENTS';
export const TOTAL_TURNOVER_VS_REVENU = 'TOTALTURNOVERVSREVENU';
export const GET_REVENUE_BY_STATUS_COUNTRY = 'GETREVENUEBYSTATUSCOUNTRY'
export const TOTAL_TURNOVER_F2F_ON_VS_REVENU = 'TOTALTURNOVERF2FONVSREVENU'

//vetting user
export const GET_ALL_SPECIALISTS = 'GETALLSPECIALISTS';
export const GET_USER_NOTIFICATIONS = 'GETUSERNOTIFICATIONS';
export const CLEAR_ALL_NOTIFICATIONS = 'CLEARALLNOTIFICATIONS';

// stats
export const RATE_VS_PATIENT = 'RATEVSPATIENT';
export const APPOINTMENT_REVENUE = 'APPOINTMENTREVENUE';
export const UPDATE_SPECIALIST_VERIFICATION = 'UPDATESPECIALISTVERIFICATION';
export const GET_ALL_PATIENTS = 'GETALLPATIENTS';
export const ADD_EMAIL_TEMPLATE = 'ADDEMAILTEMPLATE';
export const GET_EMAIL_TEMPLATES = 'GETEMAILTEMPLATES';
export const GET_EMAIL_TEMPLATE_BY_ID = 'GETEMAILTEMPLATEBYID';
export const GET_PAGES_LIST = 'GETPAGESLIST';
export const GET_PAGE_BY_ID = 'GETPAGEBYID';
export const ADD_EDIT_PAGE = 'ADDEDITPAGE';
export const GET_LOGS_LIST = 'GETLOGSLIST';
export const GET_FEEDBACKS_LIST = 'GETFEEDBACKSLIST';
export const UPDATE_FEEDBACK_STATUS = 'UPDATEFEEDBACKSTATUS';
export const CHANGE_USER_STATUS = 'CHANGEUSERSTATUS';
export const MEDFIX_REVENUE = 'MEDFIXREVENUE';


// Marketing
export const GET_MARKETING_SPECIALIZATION = 'GETMARKETINGSPECIALIZATION';
export const GET_MARKETING_SPECIALISTS_LIST = 'GETMARKETINGSPECIALISTSLIST';
export const GET_MARKET_OTHER_CONSULTATION_ADDRESS = 'GETMARKETOTHERCONSULTATIONADDRESS';
export const GET_CMS_PAGE_CONTENT = 'GETCMSPAGECONTENT';


// calendar integration
export const SEARCH_COMPLETE = 'SEARCH_COMPLETE';
export const GAPI_AUTH = 'GAPI_AUTH';
export const PUT_REVOKE_GAPI_TOKEN = 'PUT_REVOKE_GAPI_TOKEN';
export const USER_GOOGLE_SYNC_OPTION = 'USER_GOOGLE_SYNC_OPTION';



//outlook Calendar
export const USER_OUTLOOK_SYNC_OPTION = 'USER_OUTLOOK_SYNC_OPTION';

//icloud Calendar
export const USER_ICLOUD_SYNC_OPTION = 'USER_ICLOUD_SYNC_OPTION';



// otp resend 
export const RESEND_OTP = 'RESENDOTP';

export const GET_PAYMENT_CONFIG = "GETPAYMENTCONFIG";

// view receipt
export const GET_APPOINTMENT_RECEIPT = "GETAPPOINTMENTRECEIPT";

// dispute
export const GET_DISP_SUB_LIST = "GETDISPSUBLIST";
export const GET_DISP_SUB_LIST_ADMIN = "GETDISPSUBLISTADMIN";
export const GET_SUBDISPUTE_DETAIL = "GETSUBDISPUTEDETAIL";
export const GET_SUBDISPUTE_LIST = "GETSUBDISPUTELIST";
export const GET_SEARCHED_DISPUTE_LIST = "GETSEARCHEDDISPUTELIST";
export const GET_DISPUTED_APPOINTMENTS = "GETDISPUTEDAPPOINTMENTS";
export const ADD_SUB_DISPUTE_CONTENT = "ADDSUBDISPUTECONTENT";
export const ADD_DISPUTE_CONTENT = "ADDDISPUTECONTENT";
export const GET_DISPUTED_APPOINTMENT_DETAILS = "GETDISPUTEDAPPOINTMENTDETAILS";
export const MARK_USER_DISPUTE_AS_RESOLVED = "MARKUSERDISPUTEASRESOLVED";

export const CHANGE_SPECIALIST_TYPE = "CHANGESPECIALISTTYPE";
export const CHANGE_FEEDBACK_TYPE = "CHANGEFEEDBACKTYPE";

export const CHANGE_SEARCHED_DATE = "CHANGESEARCHEDDATE";
export const SPECIALIST_DETAIL_FOR_APPOINTMENT = "SPECIALISTDETAILFORAPPOINTMENT";